module.exports = __webpack_public_path__ + "img/gamma3ex_bg.6f8ab051.png";